import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import { useParams } from 'react-router-dom';
import "../AdminDashboard.css";
import Pagination from "../../Whatsapp/Pagination";
import { Form, FormControl, Button } from "react-bootstrap";
import MyContext from "../../../MyContext";
import * as XLSX from "xlsx";
function AdminPaymentReports() {
    const { clientId } = useParams();
    const { clientName } = useParams();
    const [userID, setuserID] = useState();
    useEffect(() => {
        if (clientId) {
            setuserID(clientId)
        }
    }, [clientId])



    const [loading, setLoading] = useState(false);
    const [Campaign, setCampaign] = useState([]);
    const [processedSettlements, setProcessedSettlements] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [wallet, setWallet] = useState({});
    const [expandedRow, setExpandedRow] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 100;
    const [analyticsData, setAnalyticsData] = useState(null);
    const [noTransaction, setNoTransaction] = useState(false);
    const { baseUrl } = useContext(MyContext);
    const { config } = useContext(MyContext);
    const [activeTab, setActiveTab] = useState("successfullOrder");
    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    // fetching the campaigns using the Anlook api.
    let BASIC_AUTH = "YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=";

    const walletBalanceApi = async () => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Basic ${BASIC_AUTH}`,
                },
            };
            const requestBody = {
                userid: userID,
            };

            const response = await axios.post(
                `${baseUrl}/api/Transactions/getWalletDetails`,
                requestBody,
                config
            );

            if (response.data.responseCode === "00") {
                setWallet(response.data.response);
            } else {
            }
        } catch { }
    };
    const processedSettlementsApi = async () => {
        try {
            setLoading(true);
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Basic ${BASIC_AUTH}`,
                },
            };

            const raw = {
                userid: userID,
                fromDate: startDate,
                toDate: endDate,
            };

            const res = await axios.post(
                `${baseUrl}/api/Transactions/v1.0/getProcessedSettlements`,
                raw,
                config
            );

            if (res.data?.responseCode === "00" && res.data.response.length > 0) {
                setProcessedSettlements(res.data.response);
            } else {
                setProcessedSettlements([]); // Clear old data when no new data found
            }
        } catch (error) {
            console.log({ error });
            setProcessedSettlements([]); // Clear on error too
        } finally {
            setLoading(false);
        }
    };

    const transactionsReportApi = async () => {
        try {
            setLoading(true);
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Basic ${BASIC_AUTH}`,
                },
            };

            const raw = {
                userid: userID,
                fromDate: startDate,
                toDate: endDate,
            };

            const res = await axios.post(
                `${baseUrl}/api/Transactions/getTransactionsReport`,
                raw,
                config
            );

            if (res.data?.responseCode === "00" && res.data.response.length > 0) {
                setCampaign(res.data.response);
            } else {
                setCampaign([]); // Clear old data when no new data found
            }
        } catch (error) {
            console.log({ error });
            setCampaign([]); // Clear on error too
        } finally {
            setLoading(false);
        }
    };



    // const filteredCampaign = Campaign.filter((item) => {
    //   if (activeTab === "un-successfullOrder") {
    //     return item.category === "incomplete_order";
    //   }
    //   return item.category !== "incomplete_order";
    // });

    const filteredCampaign = Campaign.filter((item) => {
        if (activeTab === "un-successfullOrder") {
            return item.category === "incomplete_order";
        } else if (activeTab === "cashSuccessfullOrder") {
            return item.payment_mode === "cash" && item.category !== "incomplete_order";
        }
        return item.category !== "incomplete_order" && item.payment_mode === "UPI";
    });

    const totalPages = Math.ceil(filteredCampaign.length / itemsPerPage);

    const handlePageClick = (page) => {
        setCurrentPage(page);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const sortedCampaign = [...filteredCampaign].sort(
        (a, b) => new Date(b.datetime) - new Date(a.datetime)
    );

    const displayedItems = sortedCampaign.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const transactionsAnalyticsApi = async () => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Basic ${BASIC_AUTH}`,
                },
            };

            const requestBody = {
                userid: userID,
                fromDate: startDate,
                toDate: endDate,
            };

            const response = await axios.post(
                `${baseUrl}/api/Transactions/v1.0/getTransactionsAnalytics`,
                requestBody,
                config
            );

            if (response.data.responseCode === "00") {
                setAnalyticsData(response.data.response);
                setNoTransaction(false);
            } else if (response.data.responseCode === "01") {
                setAnalyticsData(null);
                setNoTransaction(true);
            }
        } catch (error) {
            console.error("Error fetching analytics data:", error);
        }
    };
    useEffect(() => {
        walletBalanceApi();
        setStartDate(getCurrentDate()); // Set today's date
        setEndDate(getCurrentDate()); // Set today's date
    }, [userID]);

    useEffect(() => {
        if (startDate && endDate) {
            transactionsReportApi();
            transactionsAnalyticsApi();
            processedSettlementsApi();
        }
    }, [userID, startDate, endDate]);

    const downloadExcel = () => {
        if (!Campaign || Campaign.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "No Data Found",
                text: "There is no data available to download.",
            });
            return;
        }

        const worksheet = XLSX.utils.json_to_sheet(Campaign);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");
        XLSX.writeFile(workbook, "Transactions_Report.xlsx");
    };

    const twoDecimalPlaces = (value) => {
        return Number(value).toFixed(2).toString();
    };




    return (
        <div className='marginRight'><>
            <div className="d-flex justify-content-center text-center">
                <ToastContainer />
            </div>
            <div>
                <div
                    className="p-4 bg-white"
                    style={{
                        height: "100vh",
                        fontFamily: "Nunito,sans-serif",
                    }}
                >
                    <div className="px-4 justify-content-center">
                        <Form className="d-flex justify-content-between pb-4">
                            <Form.Label className="CreateCampaign">Payment Report of {clientName}</Form.Label>
                            <div className="d-flex justify-content-end gap-3">
                                <div className="d-flex justify-content-center align-items-center">
                                    <div className=" bg-light px-2 border-15-only d-flex justify-content-center align-items-center py-2 ">
                                        <span className="text-dark single-line-css">
                                            Wallet Balance :{" "}
                                            <span className="ms-2 text-3-2 text-success ">
                                                ₹ {parseFloat(wallet.walletBalance || 0.0).toFixed(2)}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center align-items-center">
                                    <div className=" bg-light px-2 border-15-only d-flex justify-content-center align-items-center py-2 ">
                                        <span className="text-dark single-line-css">
                                            Unsettled Amount :{" "}
                                            <span className="ms-2 text-3-2 text-success ">
                                                ₹ {parseFloat(wallet.unsettledAmount || 0.0).toFixed(2)}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center align-items-center">
                                    {/* <label
                            htmlFor="start-date"
                            className="single-line-css d-flex align-items-center"
                          >
                            Start Date
                          </label> */}
                                    <FormControl
                                        type="date"
                                        id="start-date"
                                        value={startDate}
                                        className="bg-light  "
                                        onChange={(e) => setStartDate(e.target.value)}
                                        placeholder="Start Date"
                                    />
                                </div>
                                <div className="d-flex justify-content-center align-items-center">
                                    {/* <label
                            htmlFor="end-date"
                            className="single-line-css d-flex align-items-center"
                          >
                            End Date
                          </label> */}
                                    <FormControl
                                        type="date"
                                        id="end-date"
                                        value={endDate}
                                        className="bg-light "
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                </div>
                                <div className="d-flex align-items-center">
                                    <Button className="  " onClick={downloadExcel}>
                                        Download
                                    </Button>
                                </div>
                            </div>
                        </Form>

                        <div className="d-flex flex-wrap gap-4 justify-content-between mb-4">
                            {noTransaction ? (
                                <>
                                    {/* Show cards with all zero values */}
                                    <div className=" z-0 border-0 rounded-4 bg-light flex-fill" style={{ minWidth: "300px" }}>
                                        <div className=" p-3">
                                            <div className="d-flex justify-content-between mb-2">
                                                <div>
                                                    <h6 className="text-muted mb-1">Total Order Amount</h6>
                                                    <h5 className="text-primary fw-bold">₹ 0.00</h5>
                                                </div>
                                                <div className="vr mx-3"></div>
                                                <div>
                                                    <h6 className="text-muted mb-1">Settlement Amount</h6>
                                                    <h5 className="text-success fw-bold">₹ 0.00</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card border-0 rounded-4 bg-light flex-fill" style={{ minWidth: "300px" }}>
                                        <div className="card-body p-3">
                                            <div className="d-flex justify-content-between mb-2">
                                                <div>
                                                    <h6 className="text-muted mb-1">Platform Charges</h6>
                                                    <h5 className="text-danger fw-bold">₹ 0.00</h5>
                                                </div>
                                                <div className="vr mx-3"></div>
                                                <div>
                                                    <h6 className="text-muted mb-1">Message Charges</h6>
                                                    <h5 className="text-warning fw-bold">₹ 0.00</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card border-0 rounded-4 bg-light flex-fill" style={{ minWidth: "300px" }}>
                                        <div className="card-body p-3">
                                            <div className="d-flex justify-content-between mb-2">
                                                <div>
                                                    <h6 className="text-muted mb-1">Total Messages</h6>
                                                    <h5 className="text-success fw-bold">0</h5>
                                                </div>
                                                <div className="vr mx-3"></div>
                                                <div>
                                                    <h6 className="text-muted mb-1">Per Message Cost</h6>
                                                    <h5 className="text-info fw-bold">₹ 0.00</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : analyticsData ? (
                                <>
                                    {/* Actual data cards */}
                                    <div className="card border-0 rounded-4 bg-white flex-fill" style={{ minWidth: "300px" }}>
                                        <div className="card-body p-3">
                                            <div className="d-flex justify-content-between mb-2">
                                                <div>
                                                    <h6 className="text-muted mb-1">Total Order Amount</h6>
                                                    <h5 className="text-primary fw-bold">
                                                        ₹ {parseFloat(analyticsData.totalOrderAmount || 0).toFixed(2)}
                                                    </h5>
                                                </div>
                                                <div className="vr mx-3"></div>
                                                <div>
                                                    <h6 className="text-muted mb-1">Settlement Amount</h6>
                                                    <h5 className="text-success fw-bold">
                                                        ₹ {parseFloat(analyticsData.totalSettlementAmount || 0).toFixed(2)}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card border-0 rounded-4 bg-white flex-fill" style={{ minWidth: "300px" }}>
                                        <div className="card-body p-3">
                                            <div className="d-flex justify-content-between mb-2">
                                                <div>
                                                    <h6 className="text-muted mb-1">Platform Charges</h6>
                                                    <h5 className="text-info fw-bold">
                                                        ₹ {parseFloat(analyticsData.totalPlatformCharges || 0).toFixed(2)}
                                                    </h5>
                                                </div>
                                                <div className="vr mx-3"></div>
                                                <div>
                                                    <h6 className="text-muted mb-1">Message Charges</h6>
                                                    <h5 className="text-primary fw-bold">
                                                        ₹ {parseFloat(analyticsData.totalMessageCharges || 0).toFixed(2)}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card border-0 rounded-4 bg-white flex-fill" style={{ minWidth: "300px" }}>
                                        <div className="card-body p-3">
                                            <div className="d-flex justify-content-between mb-2">
                                                <div>
                                                    <h6 className="text-muted mb-1">Total Messages</h6>
                                                    <h5 className="text-success fw-bold">{analyticsData.totalMessages || 0}</h5>
                                                </div>
                                                <div className="vr mx-3"></div>
                                                <div>
                                                    <h6 className="text-muted mb-1">Per Message Cost</h6>
                                                    <h5 className="text-info fw-bold">
                                                        ₹ {parseFloat(analyticsData.perMessageCost || 0).toFixed(2)}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                        </div>


                        <div>
                            <ul className="nav nav-tabs mb-4 bg-light p-2 rounded ">
                                {[
                                    { key: "successfullOrder", label: "UPI Orders" },
                                    { key: "cashSuccessfullOrder", label: "Cash Orders" },
                                    {
                                        key: "un-successfullOrder",
                                        label: "Un-Successfull Orders",
                                    },
                                    {
                                        key: "ProcessedSettlements",
                                        label: "Processed Settlements",
                                    },
                                ].map((tab) => (
                                    <li className="nav-item" key={tab.key}>
                                        <button
                                            className={`nav-link fw-semibold rounded-top px-3 py-2 mx-1 ${activeTab === tab.key
                                                ? "active order-section-button bg-green-order  text-white"
                                                : "text-dark bg-light"
                                                }`}
                                            onClick={() => setActiveTab(tab.key)}
                                        >
                                            {tab.label}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>



                        {loading ? (
                            <div className="m-5 p-5 d-flex justify-content-center">
                                <div className="loader"></div>
                            </div>
                        ) : (
                            <>
                                {activeTab === "successfullOrder" && (
                                    <>
                                        <table className="table table-hover">
                                            <thead style={{ borderRadius: "10px" }}>
                                                <tr
                                                    className="text-center"
                                                    style={{
                                                        borderBottom: "1px solid #ccc",
                                                    }}
                                                >
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            borderRadius: "7px 0px 0px 7px",
                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        S.No.
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Date
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Reference No.
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark single-line-css"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Order Type
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark single-line-css"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Order ID
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark single-line-css"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Customer Name
                                                    </th>

                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        <span className="single-line-css">
                                                            Order Amount
                                                        </span>
                                                        <div
                                                            className=" single-line-css"
                                                            style={{
                                                                fontSize: "0.8rem", // Smaller text size
                                                                fontWeight: "bold", // Bold font
                                                                opacity: 1, // Slightly lower opacity for a more professional look
                                                            }}
                                                        >
                                                            (GST included)
                                                        </div>
                                                    </th>

                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Net Charges <br />
                                                        Deduction
                                                    </th>

                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Net Settlement
                                                        <div>Amount</div>
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            borderRadius: "0px 7px 7px 0px",
                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Settlement
                                                        <br /> Status
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {displayedItems.length === 0 ? (
                                                    <>
                                                        {loading ? (
                                                            <tr>
                                                                <td colSpan="10" className="text-center py-5">
                                                                    <div className="m-5 p-5 d-flex justify-content-center">
                                                                        <div className="loader"></div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="10" className="text-center py-3">
                                                                    No Payment Records Found for Selected Date!
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </>
                                                ) : (
                                                    displayedItems.map((item, index) => (
                                                        <React.Fragment key={index}>
                                                            <tr
                                                                style={{
                                                                    borderBottom: "1px solid #DDD",
                                                                    padding: "5px 0px",
                                                                }}
                                                            >
                                                                <td className="p-3 text-center align-middle">
                                                                    {(currentPage - 1) * itemsPerPage + index + 1}
                                                                </td>
                                                                <td className="p-3 text-center align-middle">
                                                                    {item.datetime}
                                                                </td>
                                                                <td className="p-3 text-center align-middle">
                                                                    {item.rrn}
                                                                </td>
                                                                <td className="p-3 text-center align-middle">
                                                                    {item.order_type
                                                                        ? item.order_type.charAt(0).toUpperCase() +
                                                                        item.order_type.slice(1)
                                                                        : "NA"}   <br />
                                                                    ({item.payment_mode})
                                                                </td>
                                                                <td className="p-3 text-center align-middle single-line-css">
                                                                    {item.refrence}
                                                                </td>
                                                                <td className="p-3 text-center align-middle">
                                                                    {item.customer_name || "NA"}
                                                                </td>

                                                                <td className="p-3 text-center align-middle fw-semibold">
                                                                    ₹ {twoDecimalPlaces(item.credit)}
                                                                </td>
                                                                <td className="p-3 text-center align-middle">
                                                                    <div className="d-flex justify-content-between align-items-center gap-2">
                                                                        <span className="fw-semibold text-dark single-line-css">
                                                                            ₹ {twoDecimalPlaces(item.totalDeduction)}
                                                                        </span>
                                                                        <button
                                                                            className={`btn btn-sm text-primary ${expandedRow === item.id ? "" : ""
                                                                                }`}
                                                                            onClick={() =>
                                                                                setExpandedRow(
                                                                                    expandedRow === item.id
                                                                                        ? null
                                                                                        : item.id
                                                                                )
                                                                            }
                                                                        >
                                                                            {expandedRow === item.id
                                                                                ? "Hide"
                                                                                : "Details"}
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                                <td className="p-3 text-center align-middle">
                                                                    <strong>₹ {twoDecimalPlaces(item.settlement_amount)}</strong>
                                                                </td>
                                                                <td className="p-3 text-center align-middle">
                                                                    {item.settlement_status === "Y" ? (
                                                                        <span
                                                                            className="text-center w-100 d-inline-block px-3 py-1"
                                                                            style={{
                                                                                color: "#0F5132",
                                                                                backgroundColor: "#D1E7DD",
                                                                                border: "1px solid #0F5132",
                                                                                borderRadius: "20px",
                                                                                fontSize: "0.9rem",
                                                                                fontWeight: "500",
                                                                            }}
                                                                        >
                                                                            Settled
                                                                        </span>
                                                                    ) : (
                                                                        <span
                                                                            className="text-center w-100 d-inline-block px-3 py-1"
                                                                            style={{
                                                                                color: "#000",
                                                                                backgroundColor: "#fff3cd",
                                                                                border: "1px solid #000",
                                                                                borderRadius: "20px",
                                                                                fontWeight: "500",
                                                                            }}
                                                                        >
                                                                            Unsettled
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                            {expandedRow === item.id && (
                                                                <tr>
                                                                    <td
                                                                        colSpan="10"
                                                                        className="p-0 bg-light shadow"
                                                                    >
                                                                        <div className="mx-3 px-4   ">
                                                                            {/* Invoice Title */}
                                                                            <div className="   py-4">
                                                                                <h5 className="mb-0 text-dark">
                                                                                    Breakdown of Charges Deducted
                                                                                </h5>
                                                                            </div>
                                                                            {/* <hr className="p-0 m-0" /> */}
                                                                            {/* WhatsApp Messaging Charges */}
                                                                            <div className="pb-2">
                                                                                <div className="fw-bold text-uppercase text-muted">
                                                                                    WhatsApp Messaging Charges
                                                                                </div>

                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>Messages Sent to Users</span>
                                                                                    <span>
                                                                                        {item.message_count} Message(s)
                                                                                    </span>
                                                                                </div>

                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>Charge per Message</span>
                                                                                    <span>₹ {twoDecimalPlaces(item.per_message_cost)}</span>
                                                                                </div>

                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>
                                                                                        Subtotal (Message Charges)
                                                                                    </span>
                                                                                    <span>₹ {twoDecimalPlaces(item.message_charges)}</span>
                                                                                </div>

                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>GST (Tax)</span>
                                                                                    <span>₹ {twoDecimalPlaces(item.message_gst)}</span>
                                                                                </div>

                                                                                <div className="d-flex justify-content-between fw-bold">
                                                                                    <span>Total Messaging Cost</span>
                                                                                    <span>
                                                                                        ₹{" "}
                                                                                        {(
                                                                                            parseFloat(item.message_charges) +
                                                                                            parseFloat(item.message_gst)
                                                                                        ).toFixed(2)}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <hr className="p-0 m-0" />
                                                                            {/* Transaction Charges */}
                                                                            <div className="py-2">
                                                                                <div className="fw-bold text-uppercase text-muted ">
                                                                                    Transaction Charges
                                                                                </div>
                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>Gateway Charges</span>
                                                                                    <span>₹ {twoDecimalPlaces(item.gateway_charges)}</span>
                                                                                </div>
                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>GST</span>
                                                                                    <span>₹ {twoDecimalPlaces(item.gateway_gst)}</span>
                                                                                </div>
                                                                            </div>
                                                                            <hr className="p-0 m-0" />
                                                                            {/* Platform Fee */}
                                                                            <div className="py-2">
                                                                                <div className="fw-bold text-uppercase text-muted ">
                                                                                    Platform Fee
                                                                                </div>
                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>Platform Charges</span>
                                                                                    <span>₹ {twoDecimalPlaces(item.charges)}</span>
                                                                                </div>
                                                                                {/* <div className="d-flex justify-content-between">
                    <span>GST (CGST + SGST)</span>
                    <span>₹ {item.tax_gst}</span>
                  </div> */}
                                                                            </div>
                                                                            {item.order_type === "home_delivery" && (
                                                                                <>
                                                                                    <hr className="p-0 m-0" />
                                                                                    <div className="py-2">
                                                                                        <div className="fw-bold text-uppercase text-muted ">
                                                                                            Order Type : {item.order_type}
                                                                                        </div>
                                                                                        <div className="d-flex justify-content-between">
                                                                                            <span>Delivery Fee</span>
                                                                                            <span>₹ {twoDecimalPlaces(item.delivery_fee)}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                            <hr className="p-0 m-0" />
                                                                            {/* Total */}
                                                                            <h6 className=" py-4 d-flex justify-content-between fw-bold">
                                                                                <span className="text-primary">
                                                                                    Total Charges Deduction
                                                                                </span>
                                                                                <span className="text-primary">
                                                                                    ₹ {twoDecimalPlaces(item.totalDeduction)}
                                                                                </span>
                                                                            </h6>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                        <div className="pb-4">
                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                onNextPage={handleNextPage}
                                                onPrevPage={handlePrevPage}
                                                onPageClick={handlePageClick}
                                            />
                                        </div>
                                    </>
                                )}
                                {activeTab === "cashSuccessfullOrder" && (
                                    <>
                                        <table className="table table-hover">
                                            <thead style={{ borderRadius: "10px" }}>
                                                <tr
                                                    className="text-center"
                                                    style={{
                                                        borderBottom: "1px solid #ccc",
                                                    }}
                                                >
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            borderRadius: "7px 0px 0px 7px",
                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        S.No.
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Date
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Reference No.
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark single-line-css"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Order Type
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark single-line-css"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Order ID
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark single-line-css"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Customer Name
                                                    </th>

                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        <span className="single-line-css">
                                                            Order Amount
                                                        </span>
                                                        <div
                                                            className=" single-line-css"
                                                            style={{
                                                                fontSize: "0.8rem", // Smaller text size
                                                                fontWeight: "bold", // Bold font
                                                                opacity: 1, // Slightly lower opacity for a more professional look
                                                            }}
                                                        >
                                                            (GST included)
                                                        </div>
                                                    </th>

                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Net Charges <br />
                                                        Deduction
                                                    </th>

                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Net Settlement
                                                        <div>Amount</div>
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            borderRadius: "0px 7px 7px 0px",
                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Settlement
                                                        <br /> Status
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {displayedItems.length === 0 ? (
                                                    <>
                                                        {loading ? (
                                                            <tr>
                                                                <td colSpan="10" className="text-center py-5">
                                                                    <div className="m-5 p-5 d-flex justify-content-center">
                                                                        <div className="loader"></div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="10" className="text-center py-3">
                                                                    No Payment Records Found for Selected Date!
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </>
                                                ) : (
                                                    displayedItems.map((item, index) => (
                                                        <React.Fragment key={index}>
                                                            <tr
                                                                style={{
                                                                    borderBottom: "1px solid #DDD",
                                                                    padding: "5px 0px",
                                                                }}
                                                            >
                                                                <td className="p-3 text-center align-middle">
                                                                    {(currentPage - 1) * itemsPerPage + index + 1}
                                                                </td>
                                                                <td className="p-3 text-center align-middle">
                                                                    {item.datetime}
                                                                </td>
                                                                <td className="p-3 text-center align-middle">
                                                                    {item.rrn}
                                                                </td>
                                                                <td className="p-3 text-center align-middle">
                                                                    {item.order_type
                                                                        ? item.order_type.charAt(0).toUpperCase() +
                                                                        item.order_type.slice(1)
                                                                        : "NA"}
                                                                    <br />
                                                                    ({item.payment_mode})
                                                                </td>
                                                                <td className="p-3 text-center align-middle single-line-css">
                                                                    {item.refrence}
                                                                </td>
                                                                <td className="p-3 text-center align-middle">
                                                                    {item.customer_name || "NA"}
                                                                </td>

                                                                <td className="p-3 text-center align-middle fw-semibold">
                                                                    ₹ {item.credit}
                                                                </td>
                                                                <td className="p-3 text-center align-middle">
                                                                    <div className="d-flex justify-content-between align-items-center gap-2">
                                                                        <span className="fw-semibold text-dark single-line-css">
                                                                            ₹ {item.totalDeduction}
                                                                        </span>
                                                                        <button
                                                                            className={`btn btn-sm text-primary ${expandedRow === item.id ? "" : ""
                                                                                }`}
                                                                            onClick={() =>
                                                                                setExpandedRow(
                                                                                    expandedRow === item.id
                                                                                        ? null
                                                                                        : item.id
                                                                                )
                                                                            }
                                                                        >
                                                                            {expandedRow === item.id
                                                                                ? "Hide"
                                                                                : "Details"}
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                                <td className="p-3 text-center align-middle">
                                                                    <strong>₹ {item.settlement_amount}</strong>
                                                                </td>
                                                                <td className="p-3 text-center align-middle">
                                                                    {item.settlement_status === "Y" ? (
                                                                        <span
                                                                            className="text-center w-100 d-inline-block px-3 py-1"
                                                                            style={{
                                                                                color: "#0F5132",
                                                                                backgroundColor: "#D1E7DD",
                                                                                border: "1px solid #0F5132",
                                                                                borderRadius: "20px",
                                                                                fontSize: "0.9rem",
                                                                                fontWeight: "500",
                                                                            }}
                                                                        >
                                                                            Settled
                                                                        </span>
                                                                    ) : (
                                                                        <span
                                                                            className="text-center w-100 d-inline-block px-3 py-1"
                                                                            style={{
                                                                                color: "#000",
                                                                                backgroundColor: "#fff3cd",
                                                                                border: "1px solid #000",
                                                                                borderRadius: "20px",
                                                                                fontWeight: "500",
                                                                            }}
                                                                        >
                                                                            Unsettled
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                            {expandedRow === item.id && (
                                                                <tr>
                                                                    <td
                                                                        colSpan="10"
                                                                        className="p-0 bg-light shadow"
                                                                    >
                                                                        <div className="mx-3 px-4   ">
                                                                            {/* Invoice Title */}
                                                                            <div className="   py-4">
                                                                                <h5 className="mb-0 text-dark">
                                                                                    Breakdown of Charges Deducted
                                                                                </h5>
                                                                            </div>
                                                                            {/* <hr className="p-0 m-0" /> */}
                                                                            {/* WhatsApp Messaging Charges */}
                                                                            <div className="pb-2">
                                                                                <div className="fw-bold text-uppercase text-muted">
                                                                                    WhatsApp Messaging Charges
                                                                                </div>

                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>Messages Sent to Users</span>
                                                                                    <span>
                                                                                        {item.message_count} Message(s)
                                                                                    </span>
                                                                                </div>

                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>Charge per Message</span>
                                                                                    <span>₹ {item.per_message_cost}</span>
                                                                                </div>

                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>
                                                                                        Subtotal (Message Charges)
                                                                                    </span>
                                                                                    <span>₹ {item.message_charges}</span>
                                                                                </div>

                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>GST (Tax)</span>
                                                                                    <span>₹ {item.message_gst}</span>
                                                                                </div>

                                                                                <div className="d-flex justify-content-between fw-bold">
                                                                                    <span>Total Messaging Cost</span>
                                                                                    <span>
                                                                                        ₹{" "}
                                                                                        {(
                                                                                            parseFloat(item.message_charges) +
                                                                                            parseFloat(item.message_gst)
                                                                                        ).toFixed(2)}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <hr className="p-0 m-0" />
                                                                            {/* Transaction Charges */}
                                                                            <div className="py-2">
                                                                                <div className="fw-bold text-uppercase text-muted ">
                                                                                    Transaction Charges
                                                                                </div>
                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>Gateway Charges</span>
                                                                                    <span>₹ {item.gateway_charges}</span>
                                                                                </div>
                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>GST</span>
                                                                                    <span>₹ {item.gateway_gst}</span>
                                                                                </div>
                                                                            </div>
                                                                            <hr className="p-0 m-0" />
                                                                            {/* Platform Fee */}
                                                                            <div className="py-2">
                                                                                <div className="fw-bold text-uppercase text-muted ">
                                                                                    Platform Fee
                                                                                </div>
                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>Platform Charges</span>
                                                                                    <span>₹ {item.charges}</span>
                                                                                </div>
                                                                                {/* <div className="d-flex justify-content-between">
                    <span>GST (CGST + SGST)</span>
                    <span>₹ {item.tax_gst}</span>
                  </div> */}
                                                                            </div>
                                                                            {item.order_type === "home_delivery" && (
                                                                                <>
                                                                                    <hr className="p-0 m-0" />
                                                                                    <div className="py-2">
                                                                                        <div className="fw-bold text-uppercase text-muted ">
                                                                                            Order Type : {item.order_type}
                                                                                        </div>
                                                                                        <div className="d-flex justify-content-between">
                                                                                            <span>Delivery Fee</span>
                                                                                            <span>₹ {item.delivery_fee}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                            <hr className="p-0 m-0" />
                                                                            {/* Total */}
                                                                            <h6 className=" py-4 d-flex justify-content-between fw-bold">
                                                                                <span className="text-primary">
                                                                                    Total Charges Deduction
                                                                                </span>
                                                                                <span className="text-primary">
                                                                                    ₹ {item.totalDeduction}
                                                                                </span>
                                                                            </h6>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                        <div className="pb-4">
                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                onNextPage={handleNextPage}
                                                onPrevPage={handlePrevPage}
                                                onPageClick={handlePageClick}
                                            />
                                        </div>
                                    </>
                                )}
                                {activeTab === "un-successfullOrder" && (
                                    <>
                                        <table className="table table-hover">
                                            <thead style={{ borderRadius: "10px" }}>
                                                <tr
                                                    className="text-center"
                                                    style={{
                                                        borderBottom: "1px solid #ccc",
                                                    }}
                                                >
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            borderRadius: "7px 0px 0px 7px",
                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        S.No.
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Date
                                                    </th>

                                                    <th
                                                        className="p-3 align-middle bg-light text-dark single-line-css"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Order ID
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark single-line-css"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Customer Name
                                                    </th>
                                                    {/* <th
            className="p-3 align-middle bg-light text-dark"
            style={{
              color: "#fff",
              
              fontSize: "0.95rem",
            }}
          >
            Mode
          </th> */}

                                                    {/* <th
            className="p-3 align-middle bg-light text-dark"
            style={{
              color: "#fff",
              
              fontSize: "0.95rem",
            }}
          >
            Debit
          </th> */}

                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Message Send
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Per Message Cost
                                                    </th>
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Toatl Message <br />
                                                        Charges Deduction
                                                    </th>
                                                    {/* <th
            className="p-3 align-middle bg-light text-dark"
            style={{
              color: "#fff",
              
              fontSize: "0.95rem",
            }}
          >
            GST
          </th> */}
                                                    {/* <th
            className="p-3 align-middle bg-light text-dark"
            style={{
              color: "#fff",
              
              fontSize: "0.95rem",
            }}
          >
           Net Settlement 
           <div>Amount</div>
           
          </th> */}
                                                    <th
                                                        className="p-3 align-middle bg-light text-dark"
                                                        style={{
                                                            color: "#fff",

                                                            borderRadius: "0px 7px 7px 0px",
                                                            fontSize: "0.95rem",
                                                        }}
                                                    >
                                                        Settlement
                                                        <br /> Status
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {displayedItems.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="10" className="text-center py-3">
                                                            No Payment Records Found for Selected Date !
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    displayedItems.map((item, index) => (
                                                        <tr
                                                            key={index}
                                                            style={{
                                                                borderBottom: "1px solid #DDD",
                                                                padding: "5px 0px",
                                                            }}
                                                        >
                                                            <td className="p-3 text-center align-middle">
                                                                {(currentPage - 1) * itemsPerPage + index + 1}
                                                            </td>
                                                            <td className="p-3 text-center align-middle">
                                                                {item.datetime}
                                                            </td>

                                                            <td className="p-3 text-center align-middle single-line-css">
                                                                {item.refrence}
                                                            </td>
                                                            <td className="p-3 text-center align-middle">
                                                                {item.customer_name || "NA"}
                                                            </td>

                                                            <td className="p-3 text-center align-middle">
                                                                {item.message_count} Message(s)
                                                            </td>
                                                            <td className="p-3 text-center align-middle">
                                                                ₹ {item.per_message_cost}
                                                            </td>
                                                            <td className="p-3 text-center align-middle">
                                                                ₹ {item.message_charges}
                                                            </td>

                                                            {/* <td className="p-3 text-center align-middle">
                                    {item.tax_gst}
                                  </td> */}
                                                            {/* <td className="p-3 text-center align-middle">
                                    <strong>{item.settlement_amount}</strong>
                                  </td> */}

                                                            <td className="p-3 text-center align-middle">
                                                                {item.settlement_status === "Y" ? (
                                                                    <span
                                                                        className="text-center w-100 d-inline-block px-3 py-1"
                                                                        style={{
                                                                            color: "#0F5132",
                                                                            backgroundColor: "#D1E7DD",
                                                                            border: "1px solid #0F5132",
                                                                            borderRadius: "20px",
                                                                            fontSize: "0.9rem",
                                                                            fontWeight: "500",
                                                                        }}
                                                                    >
                                                                        Settled
                                                                    </span>
                                                                ) : (
                                                                    <span
                                                                        className="text-center w-100 d-inline-block px-3 py-1"
                                                                        style={{
                                                                            color: "#000",
                                                                            backgroundColor: "#fff3cd",
                                                                            border: "1px solid #000",
                                                                            borderRadius: "20px",
                                                                            fontWeight: "500",
                                                                        }}
                                                                    >
                                                                        Unsettled
                                                                    </span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                        <div className="pb-4">
                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                onNextPage={handleNextPage}
                                                onPrevPage={handlePrevPage}
                                                onPageClick={handlePageClick}
                                            />
                                        </div>
                                    </>
                                )}

                                {activeTab === "ProcessedSettlements" && (
                                    <>
                                        <table className="table table-hover">
                                            <thead>
                                                <tr className="text-center">


                                                    <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>S.No.</th>
                                                    <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>From Date</th>
                                                    <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>To Date</th>
                                                    <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Message Charges</th>
                                                    <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Platform Charges</th>
                                                    <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Delivery Charges</th>



                                                    <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Net Processed Settlement Amount</th>


                                                </tr>
                                            </thead>
                                            <tbody>
                                                {processedSettlements.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="4" className="text-center py-3">
                                                            No Processed Settlements Records Found for Selected Date!
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    processedSettlements.map((item, index) => (
                                                        <tr key={index} className="text-center">
                                                            <td className="p-3 align-middle">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                                            <td className="p-3 align-middle">{item.from_date}</td>
                                                            <td className="p-3 align-middle">{item.to_date}</td>
                                                            <td className="p-3 align-middle">₹ {Number(item.messageCharges).toFixed(2)}</td>

                                                            <td className="p-3 align-middle">₹ {Number(item.platformCharges).toFixed(2)}</td>

                                                            <td className="p-3 align-middle">₹ {Number(item.deliveryCharges).toFixed(2)}</td>

                                                            <td className="p-3 align-middle text-success fw-bold">₹ {parseFloat(item.amount).toFixed(2)}</td>

                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>





                                        {/* <div className="pb-4">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onNextPage={handleNextPage}
                onPrevPage={handlePrevPage}
                onPageClick={handlePageClick}
              />
            </div> */}
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </></div>
    )
}

export default AdminPaymentReports